// extracted by mini-css-extract-plugin
module.exports = {"total":"InventoryChange_total__1w_Wq","content":"InventoryChange_content__32xqf","inventoryChange":"InventoryChange_inventoryChange__2aCn9"};